// Copyright (c) Move Closer 2022.

import { ValidationMessages } from '../../molecules/Form'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const messagesEN: ValidationMessages = {
  accepted: () => 'The :attribute must be accepted.',
  accepted_if: () => 'The :attribute must be accepted when :other is :value.',
  // active_url: ({ value }) => {
  // This cannot be supported because JS does not support hostname lookups (dns_get_record in PHP)
  // This could be implemented if there was a reliable way to host a small API to do the lookup
  // },
  after: () => 'The :attribute must be after :date.',
  after_or_equal: () => 'The :attribute must be after or equal to :date.',

  alpha: () => 'The :attribute may only contain letters.',
  alpha_dash: () => 'The :attribute may only contain letters, numbers, dashes and underscores.', // I don't think that's what this rule does
  alpha_num: () => 'The :attribute may only contain letters and numbers.',

  array: () => 'The :attribute must be an array.',

  // bail: is on by default but is `validateForm` call

  before: () => 'The :attribute must be before :date.',
  before_or_equal: () => 'The :attribute must be before or equal to :date.',

  between: () => 'The :attribute must be between :min and :max', // TODO this one is more complicated

  boolean: () => 'The :attribute field must be true or false.',

  confirmed: () => 'The :attribute confirmation does not match.',

  date: () => 'The :attribute is not a valid date.',
  date_equals: () => 'The :attribute must be a date equal to :date.',
  date_format: () => 'The :attribute does not match the format :format.',

  declined: () => 'You must decline :attribute.',
  declined_if: () => 'You must decline :attribute if :other is :value.',

  different: () => 'The :attribute and :other must be different.',

  digits: () => 'The :attribute must be :digits digits.',
  digits_between: () => 'The :attribute must be between :min and :max digits.',

  dimensions: () => 'The :attribute has invalid image dimensions.',

  distinct: () => 'The :attribute field has a duplicate value.',

  email: () => 'The :attribute must be a valid email address.',

  file: () => 'The :attribute must be a file.',

  filled: () => 'The :attribute field must have a value.',

  gt: () => 'The :attribute must be greater than :value.', // TODO this one is more complicated
  gte: () => 'The attribute must be greater than or equal to :value.', // TODO this one is more complicated

  image: () => 'The :attribute must be an image.',

  in: () => 'The selected :attribute is invalid.',
  in_array: () => 'The :attribute field does not exist in :other.',

  integer: () => 'The :attribute must be an integer.',

  ip: () => 'The :attribute must be a valid IP address.',
  ipv4: () => 'The :attribute must be a valid IPv4 address.',
  ipv6: () => 'The :attribute must be a valid IPv6 address.',

  json: () => 'The :attribute must be a valid JSON string.',

  lt: () => 'The :attribute must be less than :value.', // TODO this is more complicated, and is it done with size?
  lte: () => 'The :attribute must be less than or equal to :value.', // TODO this is more complicated, and is it done with size?

  mac_access: () => 'Invalid MAC address.',

  max: () => 'The :attribute may not be greater than :max.',

  multiple_of: () => 'The :attribute must be a multiple of :value.',

  // mimes?
  // mimetypes?

  min: () => 'The :attribute must be at least :min.',

  not_in: () => 'The selected :attribute is invalid.',

  // not_regex

  // nullable: implemented in `validateField` method (index.js)

  numeric: () => 'The :attribute must be a valid number.',

  present: () => 'The :attribute field must be present.',

  regex: () => 'The :attribute is not a valid regular expression.',

  required: () => 'The :attribute field is required.',
  required_if: () => 'The :attribute field is required.',
  required_unless: () => 'The :attribute field is required unless :other is in :values.',
  required_with: () => 'The :attribute field is required when :values is present.',
  required_with_all: () => 'The :attribute field is required when :values are present.',
  required_without: () => 'The :attribute field is required when :values is not present.',
  required_without_all: () => 'The :attribute field is required when none of :values are present.',

  same: () => 'The :attribute and :other must match.',

  size: () => '', // TODO this is more complicated

  // TODO starts_with

  string: () => 'The :attribute must be a string.',

  timezone: () => 'The :attribute must be a valid zone.',

  // TODO unique

  url: () => 'The :attribute format is invalid.',

  uuid: () => 'The :attribute must be a valid UUID.'
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const messagesPL: ValidationMessages = {
  accepted: () => ':attribute musi zostać zaakceptowany.',
  accepted_if: () => 'The :attribute must be accepted when :other is :value.',
  // active_url: ({ value }) => {
  // This cannot be supported because JS does not support hostname lookups (dns_get_record in PHP)
  // This could be implemented if there was a reliable way to host a small API to do the lookup
  // },
  after: () => ':attribute musi być datą późniejszą od :date.',
  after_or_equal: () => ':attribute musi być datą nie wcześniejszą niż :date.',

  alpha: () => ':attribute może zawierać jedynie litery.',
  alpha_dash: () => ':attribute może zawierać jedynie litery, cyfry i myślniki.', // I don't think that's what this rule does
  alpha_num: () => ':attribute może zawierać jedynie litery i cyfry.',

  array: () => ':attribute musi być wypełniony.',

  // bail: is on by default but is `validateForm` call

  before: () => ':attribute musi być datą wcześniejszą od :date.',
  before_or_equal: () => ':attribute musi być datą nie późniejszą niż :date.',

  between: () => ':attribute musi zawierać się w granicach :min - :max.', // TODO this one is more complicated

  boolean: () => ':attribute musi mieć wartość prawda albo fałsz',

  confirmed: () => 'Potwierdzenie :attribute nie zgadza się.',

  date: () => ':attribute nie jest prawidłową datą.',
  date_equals: () => 'The :attribute must be a date equal to :date.',
  date_format: () => ':attribute nie jest w formacie :format.',

  declined: () => 'You must decline :attribute.',
  declined_if: () => 'You must decline :attribute if :other is :value.',

  different: () => ':attribute oraz :other muszą się różnić.',

  digits: () => ':attribute musi składać się z :digits cyfr.',
  digits_between: () => ':attribute musi mieć od :min do :max cyfr.',

  dimensions: () => ':attribute ma niepoprawne wymiary.',

  distinct: () => ':attribute ma zduplikowane wartości.',

  email: () => 'Format :attribute jest nieprawidłowy.',

  file: () => ':attribute musi być plikiem.',

  filled: () => 'Pole :attribute jest wymagane.',

  gt: () => ':attribute musi być większy niż :value.', // TODO this one is more complicated
  gte: () => ':attribute musi być większy lub równy :value.', // TODO this one is more complicated

  image: () => ':attribute musi być obrazkiem.',

  in: () => 'Zaznaczony :attribute jest nieprawidłowy.',
  in_array: () => ':attribute nie znajduje się w :other.',

  integer: () => ':attribute musi być liczbą całkowitą.',

  ip: () => ':attribute musi być prawidłowym adresem IP.',
  ipv4: () => ':attribute musi być prawidłowym adresem IPv4.',
  ipv6: () => ':attribute musi być prawidłowym adresem IPv6.',

  json: () => ':attribute musi być poprawnym ciągiem znaków JSON.',

  lt: () => ':attribute musi być mniejszy niż :value.', // TODO this is more complicated, and is it done with size?
  lte: () => ':attribute musi być mniejszy lub równy :value.', // TODO this is more complicated, and is it done with size?

  mac_access: () => 'Invalid MAC address.',

  max: () => ':attribute nie może być dłuższy niż :max.',

  multiple_of: () => 'The :attribute must be a multiple of :value.',

  // mimes?
  // mimetypes?

  min: () => ':attribute musi mieć przynajmniej :min znaków',

  not_in: () => 'Zaznaczony :attribute jest nieprawidłowy.',

  // not_regex

  // nullable: implemented in `validateField` method (index.js)

  numeric: () => ':attribute musi być liczbą.',

  present: () => 'Pole :attribute musi być obecne.',

  regex: () => 'Format :attribute jest nieprawidłowy.',

  required: () => 'Pole :attribute jest wymagane.',
  required_if: () => 'Pole :attribute jest wymagane.',
  required_unless: () => ':attribute jest wymagany jeżeli :other nie znajduje się w :values.',
  required_with: () => 'Pole :attribute jest wymagane gdy :values jest obecny.',
  required_with_all: () => 'Pole :attribute jest wymagane gdy :values jest obecny.',
  required_without: () => 'Pole :attribute jest wymagane gdy :values nie jest obecny.',
  required_without_all: () => 'Pole :attribute jest wymagane gdy żadne z :values nie są obecne.',

  same: () => 'Pole :attribute i :other muszą się zgadzać.',

  size: () => ':attribute musi mieć rozmiar :size.', // TODO this is more complicated

  // TODO starts_with

  string: () => ':attribute musi być ciągiem znaków.',

  timezone: () => ':attribute musi być prawidłową strefą czasową.',

  // TODO unique

  url: () => 'Format :attribute jest nieprawidłowy.',

  uuid: () => ':attribute musi być poprawnym identyfikatorem UUID.'
}
